import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/InitialTestReportModal.css';

const InitialTestReportModal = ({ report, onConfirm }) => {
  const { t } = useTranslation();

  if (!report) return null;

  const {
    suggested_level,
    overall_score,
    strengths = [],
    weaknesses = [],
    recommendations = []
  } = report;

  return (
    <div className="initial-test-report-modal-overlay">
      <div className="initial-test-report-modal-content">
        <div className="initial-test-report-modal-header">
          <h2>{t('initialTestReport.title') || 'Initial Test Report'}</h2>
        </div>
        
        <div className="initial-test-report-modal-body">
          <div className="report-section score-section">
            <h3>{t('initialTestReport.overallScore') || 'Overall Score'}</h3>
            <div className="score-display">{overall_score || 'N/A'}</div>
          </div>

          <div className="report-section">
            <h3>{t('initialTestReport.suggestedLevel') || 'Suggested Level'}</h3>
            <p className="suggested-level">{suggested_level || 'N/A'}</p>
          </div>

          {strengths.length > 0 && (
            <div className="report-section">
              <h3>{t('initialTestReport.strengths') || 'Strengths'}</h3>
              <ul>
                {strengths.map((strength, index) => (
                  <li key={index}>{strength}</li>
                ))}
              </ul>
            </div>
          )}

          {weaknesses.length > 0 && (
            <div className="report-section">
              <h3>{t('initialTestReport.weaknesses') || 'Areas for Improvement'}</h3>
              <ul>
                {weaknesses.map((weakness, index) => (
                  <li key={index}>{weakness}</li>
                ))}
              </ul>
            </div>
          )}

          {recommendations.length > 0 && (
            <div className="report-section">
              <h3>{t('initialTestReport.recommendations') || 'Recommendations'}</h3>
              <ul>
                {recommendations.map((rec, index) => (
                  <li key={index}>{rec}</li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="initial-test-report-modal-footer">
          <button onClick={onConfirm} className="confirm-btn">
            {t('initialTestReport.confirm') || 'Got it'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InitialTestReportModal;
